import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import { LoginParam, ConnectionParam, LoginAnswer } from '@/generated/classes/Session';
import User from '@/generated/classes/User';

type LogoutMethod = () => void;

@Module({ name: 'storeSession' })
export default class storeSession extends VuexModule {

  public sHttpCx?: AxiosInstance;
  public sHubCx?: signalR.HubConnection;
  public sHubReady = false;
  public sHubUsed = true;
  public sLogingOut = false;
  public sUser: User | null = null;
  private sToken = '';
  public sHttpAuthor: AxiosRequestConfig | undefined = undefined;
  public sSessionValid = false;
  public sLogoutMethod?: LogoutMethod;
  public sError = false;
  public sErrorMessage = '';
  public sBlCompany = 'Intuitive RH';
  public showList = false;
  public sSudo = false;

  get GetShowList (): boolean {
    return this.showList;
  }
  @Mutation
  public SetShowList (value: boolean) {
    this.showList = value;
  }
  get GetBlCompany (): string {
    return this.sBlCompany;
  }
  @Mutation
  public SetBlCompany (value: string): void {
    this.sBlCompany = value;
  }

  get modeLocal (): boolean {
    return false;
  }
  get httpCx (): AxiosInstance | undefined {
    return this.sHttpCx;
  }
  get httpAuthor (): AxiosRequestConfig | undefined {
    return this.sHttpAuthor;
  }
  get httpToken (): string {
    return this.sToken;
  }
  get hubUsed (): boolean {
    return this.sHubUsed;
  }
  get hubReady (): boolean {
    console.log('hubReady : ', this.sHubReady);
    return this.sHubReady;
  }
  get hubCx (): signalR.HubConnection | undefined {
    return this.sHubCx;
  }
  get sessionValid (): boolean {
    return this.sSessionValid;
  }
  get connectedUser (): User | null {
    return this.sUser;
  }
  get error (): boolean {
    return this.sError;
  }
  get errorMessage (): string {
    return this.sErrorMessage;
  }
  get logged (): boolean {
    return this.sUser !== null && this.sUser.id > 0;
  }
  get logoutMethod (): LogoutMethod | undefined {
    return this.sLogoutMethod;
  }
  get loginOut (): boolean {
    return this.sLogingOut;
  }
  get isSudo (): boolean {
    return this.sSudo;
  }

  @Mutation
  public SET_USER_DATA (loginAnswer: LoginAnswer): void {
    this.sUser = loginAnswer.user;
    this.sSudo = loginAnswer.isSudo;
    localStorage.setItem('user', JSON.stringify(loginAnswer));
    this.sToken = loginAnswer.token;
    this.sHttpAuthor = {
      headers: {
        Authorization: loginAnswer.token
      }
    };

    this.sSessionValid = this.sHttpAuthor !== undefined && this.sUser !== null;
    console.log('session valid : ', this.sSessionValid);
    console.log("Token", loginAnswer.token)
    console.log('user : ', this.sUser);
  }

  @Mutation
  public clearData (): void {
    this.sUser = null;
    this.sHttpAuthor = undefined;
    this.sSessionValid = false;
    localStorage.removeItem('user');
    axios.defaults.headers.common.Authorization = null;
  }
  @Mutation
  public SET_LOGOUT_METHOD (method: LogoutMethod): void {
    this.sLogoutMethod = method;
  }
  @Mutation
  public SET_CONNEXION (httpCx: AxiosInstance): void {
    this.sHttpCx = httpCx;
  }
  @Mutation
  public SET_HUB_CX (hubCx: signalR.HubConnection): void {
    this.sHubCx = hubCx;
  }
  @Mutation
  public SET_HUB_READY (ready: boolean): void {
    this.sHubReady = ready;
    console.log('hub connected ' + ready);
  }
  @Mutation
  public SET_LOGIN_OUT (state: boolean): void {
    this.sLogingOut = state;
  }

  @Action
  public setToken (token: string, client98: number, user?: User): void {
    const loginAnswer = new LoginAnswer();
    loginAnswer.token = token;
    loginAnswer.user = user ?? new User();
    loginAnswer.user.client98 = client98;
    this.context.commit('SET_USER_DATA', loginAnswer);
  }
  @Action
  public setConnexion (httpCx: AxiosInstance): void {
    this.context.commit('SET_CONNEXION', httpCx);
  }
  @Action
  public setHubCx (hubCx: signalR.HubConnection): void {
    this.context.commit('SET_HUB_CX', hubCx);
  }
  @Action
  public setHubReady (ready: boolean): void {
    this.context.commit('SET_HUB_READY', ready);
  }
  @Action
  public setUserData (userData: User): void {
    this.context.commit('SET_USER_DATA', userData);
  }

  @Action
  public login (param: LoginParam): Promise<LoginAnswer> {
    return new Promise((resolve) => {
      if (this.httpCx !== undefined) {
        this.context.commit('SET_LOGIN_OUT', false);
        param.userAgent = navigator.userAgent;
        return this.httpCx.post('login', param)
          .then(({ data }: { data: LoginAnswer }) => {
            if (data.token != '') {
              this.context.commit('SET_USER_DATA', data);
            }
            resolve(data);
          })
      }
    })
  }
  @Action
  public sudo (userId: number): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.httpCx !== undefined) {
        this.context.commit('SET_LOGIN_OUT', true);
        return this.httpCx.get('login/' + userId.toString(), this.httpAuthor)
          .then(({ data }: { data: LoginAnswer }) => {
            this.context.commit('SET_LOGIN_OUT', false);
            if (this.hubCx !== undefined) {
              this.hubCx.stop();
            }
            this.context.dispatch('clearStoresData');
            this.context.commit('clearData');
            if (data.token != '') {
              this.context.commit('SET_USER_DATA', data);
              resolve(true);
            } else {
              resolve(false);
            }
          })
      }
    })
  }
  @Action
  public resynch (): void {
      if (this.httpCx !== undefined) {
        this.httpCx.get('login/resynch', this.httpAuthor)       
        console.log('resynch');
      }
  }
  @Action
  public stopHubCx (): void {
    if (this.hubCx !== undefined) {
      this.hubCx.stop();
    }
  }
  @Action
  public startHubCx (): void {
    if (this.hubCx !== undefined) {
      this.hubCx.start();
    }
  }

  @Action
  public openSession (token: string): Promise<LoginAnswer> {
    return new Promise((resolve) => {
      if (this.httpCx !== undefined) {
        this.context.commit('SET_LOGIN_OUT', false);
        const tmpAuthor = {
          headers: {
            Authorization: token
          }
        }
        return this.httpCx.post('login', new LoginParam(), tmpAuthor)
          .then(({ data }: { data: LoginAnswer }) => {
            if (data.token != '') {
              this.context.commit('SET_USER_DATA', data);
            }
            resolve(data);
          })
      }
    })
  }
  @Action
  public setConnectionMode (param: ConnectionParam): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.httpCx !== undefined) {
        return this.httpCx.post('login/set_cx_mode', param, this.httpAuthor)
          .then(() => {
            resolve(true);
          })
      }
    })
  }
  @Action
  public setPassword (param: ConnectionParam): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.httpCx !== undefined) {
        return this.httpCx.post('login/set_password', param, this.httpAuthor)
          .then(() => {
            resolve(true);
          })
      }
    })
  }
  @Action
  public resetParam (param: LoginParam): Promise<LoginAnswer> {
    return new Promise((resolve) => {
      if (this.httpCx !== undefined) {
        return this.httpCx.post('login/reset_param', param)
          .then(({ data }: { data: LoginAnswer }) => {
            resolve(data);
          })
      }
    })
  }

  @Action
  public resetToken (param: LoginParam): Promise<LoginAnswer> {
    return new Promise((resolve) => {
      if (this.httpCx !== undefined) {
        param.userAgent = navigator.userAgent;
        return this.httpCx.post('login/reset_token', param, this.httpAuthor)
          .then(({ data }: { data: LoginAnswer }) => {
            if (data.token != '') {
              this.context.commit('SET_USER_DATA', data);
            }
            resolve(data);
          })
      }
    })
  }

  @Action
  public logout (): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.loginOut) {
        this.context.commit('SET_LOGIN_OUT', true);
        if (this.httpCx !== undefined) {
          return this.httpCx.post('login/logout', {}, this.httpAuthor)
            .then(({ data }: { data: LoginAnswer }) => {
              this.context.commit('SET_LOGIN_OUT', false);
              this.context.dispatch('clearStoresData');
              this.context.commit('clearData');
              if (this.hubCx !== undefined) {
                this.hubCx.stop();
              }
              if (data.token != '') {
                this.context.commit('SET_USER_DATA', data);
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch(() => {
              this.context.commit('SET_LOGIN_OUT', false);
              resolve(true);
            })
        }
      }
    })
  }
  @Action
  public setLogoutMethod (method: () => void): void {
    this.context.commit('SET_LOGOUT_METHOD', method)
  }
  @Action
  public clearStoresData (): void {
    this.context.dispatch('clearData');
  }
}
